import React from 'react';
import PropTypes from 'prop-types';
import { BodyItem, ItemName, ItemContent } from './styles/SettingItemStyles';

/**
 * 設定項目の枠組みを作成するコンポーネント
 * @param {string} title - 設定項目のタイトル
 * @param {node} children - 設定項目の内容
 * @param {boolean} isLastElement - 最後の要素かどうか
 * @returns
 */
// eslint-disable-next-line arrow-body-style
const SettingItem = ({ title, children, isLastElement }) => {
  return (
    <BodyItem>
      <ItemName isLastElement={isLastElement}>
        <p>{title}</p>
      </ItemName>
      <ItemContent isLastElement={isLastElement}>{children}</ItemContent>
    </BodyItem>
  );
};

SettingItem.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  isLastElement: PropTypes.bool,
};

SettingItem.defaultProps = {
  children: null,
  isLastElement: false,
};

export default SettingItem;
